"use client";

import React from "react";
import { PhoneForwarded, Headset, Wifi, Network, Server, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  title: "POTS Line Replacement",
  description: "Legacy copper to cloud voice migration. We assess your setup, coordinate the cutover, and handle the physical installation. Your numbers stay, your bill drops.",
  icon: PhoneForwarded,
  label: "01/POTS-MIG"
}, {
  title: "UCaaS Installation & Support",
  description: "Hosted phone system deployment using industry-leading hardware. We source it, configure it, install it, and support it after the sale.",
  icon: Headset,
  label: "02/UCAAS-VOICE"
}, {
  title: "Internet & Cellular Backup",
  description: "Reliable cellular failover and primary internet solutions sourced through our carrier network. We ensure your business stays online even when the main line fails.",
  icon: Wifi,
  label: "03/CONNECT-PRO"
}, {
  title: "Cable & Patch Panel Cleanup",
  description: "MDF/Server Room remediation to properly manage, label, and structure your cabling. We remove abandoned patches and provide full documentation for future-proofing.",
  icon: Network,
  label: "04/CABLE-CLEAN"
}, {
  title: "Hardware & Device Sales",
  description: "Direct sourcing and sales of enterprise-grade networking hardware, UCaaS devices, and security equipment. We provide the right gear with full manufacturer support.",
  icon: Server,
  label: "05/INFRA-BUILD"
}, {
  title: "Structured Cabling",
  description: "Professional installation of Cat6, fiber optics, and low-voltage wiring for new construction or office expansions. Built to industry standards for maximum performance.",
  icon: ShieldCheck,
  label: "06/SECURE-WATCH"
}];
export default function PartnersInProgress() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224151" id="the-kc-advantage" className="w-full py-16 md:py-24 lg:py-32 dark bg-background text-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[linear-gradient(to_right,#808080_1px,transparent_1px),linear-gradient(to_bottom,#808080_1px,transparent_1px)] bg-[size:40px_40px]"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center justify-center text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold font-default text-foreground tracking-tighter mb-4 uppercase">
            VOLTEX IT Field Services
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-3xl">
            We specialize in POTS line replacement, UCaaS installation, backup internet connectivity, cable infrastructure cleanup, network deployment, and security monitoring. Owner-operated field execution with local accountability.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {sectors.map((sector, i) => {
          const Icon = sector.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full border-t-4 border-t-primary border-x-border border-b-border bg-card/50 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_-10px_rgba(210,255,0,0.2)] group">
                  <CardHeader className="pb-4">
                    <div className="flex justify-between items-start mb-4">
                      <div className="inline-flex items-center justify-center rounded-lg bg-primary/10 p-3 w-fit">
                        <Icon className="size-12 text-primary" strokeWidth={1.5} />
                      </div>
                      <span className="font-mono text-[10px] tracking-widest text-primary/70 uppercase">
                        {sector.label}
                      </span>
                    </div>
                    <CardTitle className="text-2xl font-bold font-default text-foreground uppercase tracking-tight">
                      {sector.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground font-default leading-relaxed text-sm">
                      {sector.description}
                    </p>
                    <div className="mt-6 h-0.5 w-0 bg-primary transition-all duration-500 group-hover:w-full"></div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}